import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from '../../styles/popups/dialog.module.css';

interface DialogProps {
    children: ReactNode;
    className?: string | null;
}

function Dialog({ children, className = null }: DialogProps) {
    return <div className={classNames([styles.container, className])}>{children}</div>;
}

export default Dialog;
